import { FormatCaseInfo } from 'types';
import { formatDate } from 'utils/date';
import { formatPrice } from 'utils/helpers';
import { FiservCaseDetail } from 'store/api/fiserv/types';

export const template = '88px repeat(2, 1fr) 72px repeat(4, 1fr)';
export const titles = [
  'Report Date',
  'Transaction Date',
  'Case Number',
  'Card Type',
  'Card Number',
  'CB Type Description',
  'CB Amount',
  'Disposition',
];

export const infoItemConfig: FormatCaseInfo<FiservCaseDetail>[] = [
  { key: 'RecordID', title: 'Record ID' },
  { key: 'CardType', title: 'Card Type Code' },
  { title: 'Card Type', key: 'CardTypeDescription' },
  { key: 'CaseNumber', title: 'Case Number' },
  { title: 'Auth Code', key: 'AuthorizationCode' },
  { key: 'ReferenceNumber', title: 'Reference Number' },
  {
    title: 'CB Amount',
    key: 'RepresentedCBAmount',
    getValue: (data) =>
      formatPrice(data?.RepresentedCBAmount || data?.TransactionAmount),
  },
  { key: 'ReasonCode', title: 'CB Reason' },
  { title: 'Reason Description', key: 'ReasonCodeDescription' },
  { key: 'ReasonText', title: 'Reason Text' },
  {
    key: 'TransactionDate',
    title: 'Transaction Date',
    format: (value) => formatDate(value),
  },
  {
    key: 'ReportDate',
    title: 'Report Date',
    format: (value) => formatDate(value),
  },
  {
    key: 'TransactionAmount',
    title: 'Transaction Amount',
  },
  { key: 'CBType', title: 'CB Type' },
  { key: 'CBTypeDescription', title: 'CB Type Description' },
  { key: 'Disposition', title: 'Disposition' },
  {
    key: 'PreDispute',
    title: 'Pre-Dispute',
    format: (v) => (v ? 'Yes' : 'No'),
  },
];
